export default function PageGrid({ pages, handleDragStart, handleDragOver, handleDrop, setActivePreviewPage, draggedItemIndex, message }) {
  return (
    <>
      {message ? (
        <div className="d-flex flex-column align-items-center justify-content-center border border-2 border-dashed rounded p-5 bg-light text-success" style={{ minHeight: '350px' }}>
          <i className="bi bi-check-circle display-4 mb-3"></i>
          <p className="m-0 fw-medium">{message}</p>
        </div>
      ) : pages.length === 0 ? (
        <div className="d-flex flex-column align-items-center justify-content-center border border-2 border-dashed rounded p-5 bg-light text-muted" style={{ minHeight: '350px' }}>
          <i className="bi bi-files display-4 mb-3"></i>
          <p className="m-0">No documents uploaded yet.</p>
        </div>
      ) : (
        <div className="row g-3 p-3 bg-light rounded border overflow-auto" style={{ maxHeight: '650px' }}>
          {pages.map((page, index) => (
            <div 
              key={page.id} 
              className="col-6 col-sm-4 text-center" 
              draggable 
              onDragStart={() => handleDragStart(index)} 
              onDragOver={handleDragOver} 
              onDrop={() => handleDrop(index)}
            >
              <div className={`card h-100 shadow-sm border p-2 bg-white ${draggedItemIndex === index ? 'opacity-25' : ''}`} style={{ cursor: 'grab' }}>
                <div className="d-flex justify-content-between align-items-center mb-1 text-muted">
                  <i className="bi bi-grip-vertical fs-5" />
                  <button 
                    type="button"
                    className="btn btn-link btn-sm text-decoration-none p-0 px-1 text-primary small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setActivePreviewPage(page);
                    }}
                    title="Open PDF Content Reader"
                  >
                    <i className="bi bi-eye-fill me-1"></i>Read
                  </button>
                </div>

                <img src={page.src} alt="thumbnail" className="img-fluid border rounded mx-auto my-1" style={{ maxHeight: '130px', pointerEvents: 'none' }} />
                
                <div className="mt-auto">
                  <div className="text-truncate text-muted px-1" style={{ fontSize: '0.65rem' }}>{page.originFile}</div>
                  <span className="badge bg-primary mt-1">Page {page.pageNumber}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </>
  );
}
